import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/Header';
import AuthForm from '../../components/AuthForm';
import './AuthPage.css';

// Hero изображение
const heroImageUrl = '/images/hero-auth.jpg';

const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, register, loginWithGoogle, loginWithVK, loginWithTelegram, isAuthenticated, error, clearError } = useAuth();
  
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/orders';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleLogin = async (credentials) => {
    setLoading(true);
    setSuccessMessage(null);
    clearError();
    
    const result = await login(credentials.email, credentials.password, credentials.captchaToken);
    
    setLoading(false);
    
    if (result.success) {
      const from = location.state?.from?.pathname || '/orders';
      navigate(from, { replace: true });
    }
  };

  const handleRegister = async (credentials) => {
    setLoading(true);
    setSuccessMessage(null);
    clearError();
    
    const result = await register(
      credentials.email, 
      credentials.password, 
      credentials.firstName,
      credentials.captchaToken
    );
    
    setLoading(false);
    
    if (result.success) {
      setSuccessMessage(result.message);
    }
  };

  const handleForgotPassword = () => {
    navigate('/reset-password');
  };

  const handleSocialLogin = async (provider) => {
    if (provider === 'google') {
      loginWithGoogle();
      return;
    }
    if (provider === 'vk') {
      loginWithVK();
      return;
    }
    if (provider === 'telegram') {
      await loginWithTelegram();
      return;
    }
    // TODO: Implement other social logins later
    console.log('Social login:', provider, '- Coming soon');
  };

  const handleClearMessages = () => {
    clearError();
    setSuccessMessage(null);
  };

  return (
    <div className="auth-page">
      <Header activeNav="auth" />
      
      <main className="auth-page__main">
        <div className="auth-page__container">
          <div className="auth-page__panel">
            <div className="auth-page__content">
              {/* Форма авторизации */}
              <div className="auth-page__form-wrapper">
                <AuthForm
                  onLogin={handleLogin}
                  onRegister={handleRegister}
                  onForgotPassword={handleForgotPassword}
                  onSocialLogin={handleSocialLogin}
                  loading={loading}
                  error={error}
                  successMessage={successMessage}
                  onClearMessages={handleClearMessages}
                />
              </div>
              
              {/* Картинка */}
              <div className="auth-page__hero">
                <div className="auth-page__hero-border">
                  <div className="auth-page__hero-image">
                    <img 
                      src={heroImageUrl} 
                      alt="GoPlayDonate - игровые персонажи" 
                      loading="eager"
                      draggable="false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthPage;
